var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.45 11.1383H10.075V5.82577C10.075 3.62108 8.44531 1.7992 6.325 1.49608V0.888268C6.325 0.542955 6.04531 0.263268 5.7 0.263268C5.35469 0.263268 5.075 0.542955 5.075 0.888268V1.49608C2.95469 1.7992 1.325 3.62108 1.325 5.82577V11.1383H0.950001C0.673438 11.1383 0.450001 11.3617 0.450001 11.6383V12.1383C0.450001 12.207 0.506251 12.2633 0.575001 12.2633H3.95C3.95 13.2289 4.73438 14.0133 5.7 14.0133C6.66563 14.0133 7.45 13.2289 7.45 12.2633H10.825C10.8938 12.2633 10.95 12.207 10.95 12.1383V11.6383C10.95 11.3617 10.7266 11.1383 10.45 11.1383ZM5.7 13.0133C5.28594 13.0133 4.95 12.6773 4.95 12.2633H6.45C6.45 12.6773 6.11406 13.0133 5.7 13.0133ZM2.45 11.1383V5.82577C2.45 4.95702 2.7875 4.14139 3.40156 3.52733C4.01563 2.91327 4.83125 2.57577 5.7 2.57577C6.56875 2.57577 7.38438 2.91327 7.99844 3.52733C8.6125 4.14139 8.95 4.95702 8.95 5.82577V11.1383H2.45Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmIcon);
export default __webpack_public_path__ + "static/media/alarmIcon.84e7e29ec19eccbf2938b811fb493216.svg";
export { ForwardRef as ReactComponent };